import { render } from "./RowsCounter.vue?vue&type=template&id=9a5fa830&scoped=true"
import script from "./RowsCounter.vue?vue&type=script&lang=js"
export * from "./RowsCounter.vue?vue&type=script&lang=js"

import "./RowsCounter.vue?vue&type=style&index=0&id=9a5fa830&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5fa830"]])

export default __exports__